import React, { useEffect } from 'react';
import { PrintContainer } from 'Utils/Print';
const logoImg = require('../../../../../../../assets/img/logo.png');
const logoCamion = require('../../../../../../../assets/img/icons/recepciones_activo.png');
import moment from "moment";
import { ResumenApi } from '../Api/ResumenApi';
import DetalleRecepcion from './DetalleRecepcion';
import LoadMask from '../../../../Utils/LoadMask/LoadMask';
import "react-datepicker/dist/react-datepicker.css";

/**
 * Componente para mostrar el resumen de creación de recepciones con contenedores.
 * @param {*} props - Propiedades del componente.
 * @param {number} props.viaje_id - ID del viaje.
 * @param {function} props.regresar - Función para regresar a la vista anterior.
 * @returns {JSX.Element} Componente de resumen de creación.
 */
const ResumenCreacion = (props) => {
    const { viaje_id, regresar, imprimir } = props;

    // __________ API __________
    const {
        getRecepcionesViaje,
        recepciones,
        cargando,
    } = ResumenApi();

    useEffect(() => {
        getRecepcionesViaje({
            viaje_id: viaje_id
        });
    }, [viaje_id]);

    const detallesGenerales = recepciones && recepciones.length > 0 ? recepciones[0] : {
        vehiculo: {},
        piloto: {},
    };

    return (
        <LoadMask loading={cargando} blur>
            <PrintContainer name='recepciones-contenedores'>
                <div className="resumen-creacion__form">
                    <div className="resumen-creacion__detalles-generales">
                        <img
                            className="d-inline-block align-top mr-auto"
                            src={logoImg}
                            alt="Logo"
                            height="50px"
                        />
                        <label className="p-0 m-0 mb-4 mt-2">ACOPIO ERSA KM. 7.5 CARRETERA A TULATE</label>

                        <div className="resumen-creacion__sub-header">
                            <div className="resumen-creacion__field-horizontal">
                                <img src={logoCamion} alt="Usuario" className="title_img mr-2" />
                                <img src={require('../../../../../../../assets/img/icons/linea.png')} alt="Linea" className="title_img mr-2" />
                                <h6 className="text-black mb-0">RESUMEN DE INGRESO</h6>
                            </div>

                            <div className="resumen-creacion__field-vertical">
                                <span className="gris">Fecha de impresión:</span>
                                <span className="gris">{moment().format('DD/MM/YYYY HH:mm:ss A')}</span>
                            </div>
                        </div>


                        <div className="resumen-creacion__fields-row">
                            <div className="resumen-creacion__field-vertical">
                                <label className="p-0 m-0">VEHÍCULO</label>
                                <span className="gris">{detallesGenerales.vehiculo.nombre}</span>
                            </div>
                            <div className="resumen-creacion__field-vertical">
                                <label className="p-0 m-0">PILOTO</label>
                                <span className="gris">{detallesGenerales.piloto.nombre}</span>
                            </div>
                        </div>

                    </div>

                    <div className="resumen-creacion__recepciones">
                        {recepciones && recepciones.length > 0 && recepciones.map((recepcion, index) => (
                            <DetalleRecepcion key={index} index={index} recepcion={recepcion} />
                        ))}
                    </div>

                    {/* ACCIONES */}
                    <div className="resumen-creacion__actions">
                        <button className="btn btn-outline-dark" onClick={() => regresar()}>CERRAR</button>
                    </div>
                </div>
            </PrintContainer >
        </LoadMask>
    )
}

export default ResumenCreacion
